<template>
  <div class="c-table" ref="labeltable">
    <!-- <Spin size="large" fix v-if="loading"></Spin> -->
    <el-table class="common-el-table-styles" v-loading="loading" :data="data" :height="height" border stripe>
      <el-table-column
        v-for="(col, id) in columns"
        :key="id"
        :prop="col.key"
        :label="col.title"
        :show-overflow-tooltip="col.overflow"
        :min-width="col.width"
        :align="col.align"
      >
        <template slot-scope="scope">
          <div v-if="col.key === 'control'">
            <el-button type="text" size="small" @click="$emit('on-edit', scope.row)">修改</el-button>
            <Poptip confirm transfer title="您确认删除该标签组吗？" @on-ok="$emit('on-del', scope.row['id'])">
              <el-button type="text" size="small" class="c-control-margin">删除</el-button>
            </Poptip>
          </div>
          <span v-else-if="col.key === 'labelDetailList'">{{ formatToString(scope.row[col.key]) }}</span>
          <span v-else-if="col.key === 'updateTime'">{{ scope.row[col.key] | datetimeToSec }}</span>
          <span v-else>{{ scope.row[col.key] }}</span>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>
<script>
import { timeout, isArray } from '@/common/js/utils'
export default {
  name: 'labeltable',
  props: {
    data: {
      type: Array,
      default() {
        return []
      }
    },
    loading: {
      type: Boolean,
      default() {
        return false
      }
    },
    columns: {
      type: Array
    }
  },
  methods: {
    formatToString(val) {
      if (isArray(val)) {
        return val.join('；')
      }
      return ''
    }
  },
  data() {
    return {
      height: 0
    }
  },
  mounted() {
    this.$nextTick(() => {
      timeout(0).then(() => {
        this.$refs.labeltable && (this.height = this.$refs.labeltable.offsetHeight - 7)
      })
    })
  }
}
</script>
<style lang="scss" scoped>
.c-table {
  position: relative;
  height: calc(100% - 32px);
  background-color: #fff;

  .el-table {
    height: 100%;
  }

  .c-control-margin {
    margin: 0;
    padding: 0 6px;
  }
}
</style>
